import React from "react";
import ReactPlayer from "react-player";
import PlayArrowRoundedIcon from "@mui/icons-material/PlayArrowRounded";

function ListingVideoTab({
  videoLink,
  displayImage,
  isPlayingVideo,
  setIsPlayingVideo,
  videoError,
  setVideoError,
  videoTourTitle,
  videoTourDesc,
}) {
  return (
    <div className="space-y-4">
      <div className="bg-white rounded-2xl border border-[#F1F5F9] overflow-hidden shadow-2xs">
        {!videoLink ? (
          <div className="relative h-[210px] w-full bg-[#F8FAFC] flex flex-col items-center justify-center p-6 text-center">
            <div className="w-12 h-12 rounded-full bg-[#F1F5F9] flex items-center justify-center text-[#999FA9] mb-2">
              <PlayArrowRoundedIcon sx={{ fontSize: 26, color: "#808285" }} />
            </div>
            <p className="text-[#1E222B] font-[600] text-[13.5px]">
              No Virtual Tour Video
            </p>
            <p className="text-[#808285] text-[11.5px] mt-0.5">
              A video tour has not been uploaded for this property yet.
            </p>
          </div>
        ) : !isPlayingVideo ? (
          <div
            onClick={() => {
              setIsPlayingVideo(true);
              setVideoError(false);
            }}
            className="relative h-[210px] w-full bg-gray-900 group cursor-pointer overflow-hidden"
          >
            <img
              src={displayImage}
              alt="Virtual Property Tour"
              className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300 opacity-90"
            />

            <div className="absolute inset-0 bg-black/20 group-hover:bg-black/10 transition-colors" />

            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-14 h-14 rounded-full bg-white shadow-xl flex items-center justify-center group-hover:scale-110 transition-transform duration-200">
              <PlayArrowRoundedIcon
                sx={{
                  fontSize: 32,
                  color: "#00BC67",
                  marginLeft: "3px",
                }}
              />
            </div>
          </div>
        ) : (
          <div className="relative h-[220px] w-full bg-black overflow-hidden flex items-center justify-center">
            {!videoError ? (
              <ReactPlayer
                url={videoLink}
                controls={true}
                playing={true}
                width="100%"
                height="100%"
                onError={(err) => {
                  console.error("Video player error:", err);
                  setVideoError(true);
                }}
              />
            ) : (
              <div className="flex flex-col items-center justify-center p-6 text-center text-white bg-black/95 h-full w-full">
                <p className="text-xs font-semibold text-gray-300 mb-2">
                  Unable to stream video directly in player
                </p>
                <a
                  href={videoLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-1.5 px-3.5 py-1.5 bg-[#00BC67] hover:bg-[#00a85c] text-white text-xs font-semibold rounded-lg transition cursor-pointer"
                >
                  Open Video Link
                </a>
              </div>
            )}
          </div>
        )}
        <div className="p-4">
          <h4 className="text-[#1E222B] font-[700] text-[14px]">
            {videoTourTitle}
          </h4>
          <p className="text-[#787F8D] font-[400] text-[12px] mt-1 leading-relaxed">
            {videoTourDesc}
          </p>
        </div>
      </div>
    </div>
  );
}

export default ListingVideoTab;
